// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"327":"845814c21bc1f351","959":"2fa80a2c4de0107a","996":"4a051ea3ef42fb58"}[chunkId] + ".js";
};